import { render } from "./OwnerCardCareerRecord.vue?vue&type=template&id=20587416&scoped=true&bindings={\"label\":\"props\",\"value\":\"props\"}"
import script from "./OwnerCardCareerRecord.vue?vue&type=script&lang=ts"
export * from "./OwnerCardCareerRecord.vue?vue&type=script&lang=ts"

import "./OwnerCardCareerRecord.vue?vue&type=style&index=0&id=20587416&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20587416"

export default script